import { IconButton, AppBar, Toolbar, Table, TableHead, TableBody, TableRow, TableCell, Checkbox, Button, Tabs, Tab, Grid, Typography, Paper, Tooltip, Divider, MenuItem, FormControl, Select, FormHelperText } from "@material-ui/core";
import * as React from "react";
import { Theme } from "@material-ui/core/styles";
import { observable, action, toJS } from "mobx";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { config } from "src/config";
import { observer } from "mobx-react";
import { history } from "src/history.js";
import { settingsStore } from '.';
import RichTextEditor from 'react-rte';
import InfoIcon from '@material-ui/icons/Info';

interface IEmailTemplate {
    email_template_id: number;
    EmailTemplateName: string;
    EmailTemplateReference: string;
    Sections: IEmailTemplateSection[];
    Variables: IEmailVariable[];
}

interface IEmailTemplateSection {
    email_template_section_id: number
    email_template_id: number;
    EmailSectionName: string;
    EmailSectionContent: string;
    EmailSectionReference: string;
    RTEValue: any;
}

interface IEmailVariable {
    email_template_variable_id: number;
    email_template_id: number;
    EmailTemplateVariable: string;
    EmailTemplateVariableDescription: string;
}

type GroupName =
    | "INLINE_STYLE_BUTTONS"
    | "BLOCK_TYPE_BUTTONS"
    | "LINK_BUTTONS"
    | "BLOCK_TYPE_DROPDOWN"
    | "HISTORY_BUTTONS"
    | "IMAGE_BUTTON";

const displayTest: GroupName[] = ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS', 'IMAGE_BUTTON']

const styles = ({ typography }: Theme) =>
    createStyles({
        root: {
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: 'hidden'
        },
        table: {
            height: "100%",
            flex: 1,
            fontFamily: "inherit",
        },
        tableIconCell: {
            display: "flex",
            justifyContent: "center",
        },
        tableIconHeader: {
            marginRight: "1rem",
        },
        tableDefaultCell: {
            marginRight: ".25rem",
            marginLeft: ".25rem",
            display: "flex",
            alignItems: "center",
            fontFamily: typography.fontFamily,
        },
        tableDefaultHeader: {
            fontFamily: typography.fontFamily,
        },
        content: {
            flex: 1,
            display: "flex",
        },
        subheaderRow: {
            backgroundColor: '#cddadb',
        },
        emailSelect: {
            fontSize: '36px',
            textAlign: 'center'
        }
    });

@observer
class SignUpEmailTemplate extends React.Component<any> {

    

    public toolbarConfig = {
        // Optionally specify the groups to display (displayed in the order listed).
        // display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS', 'IMAGE_BUTTON'],
        display: displayTest,
        INLINE_STYLE_BUTTONS: [
            { label: 'Bold', style: 'BOLD', className: 'custom-css-class' },
            { label: 'Italic', style: 'ITALIC' },
            { label: 'Underline', style: 'UNDERLINE' }
        ],
        BLOCK_TYPE_DROPDOWN: [
            { label: 'Normal', style: 'unstyled' },
            { label: 'Heading Large', style: 'header-one' },
            { label: 'Heading Medium', style: 'header-two' },
            { label: 'Heading Small', style: 'header-three' }
        ],
        BLOCK_TYPE_BUTTONS: [
            { label: 'UL', style: 'unordered-list-item' },
            { label: 'OL', style: 'ordered-list-item' },
        ],
    };

    constructor(props: any) {
        super(props);
    }

    public componentDidMount = async () => {
        // await settingsStore.getEmailTemplates()
    }

    public handleContentChange = (e: any, template_id: number, section_id: number) => {
        settingsStore.template_saved = false;
        settingsStore.EmailTemplates = settingsStore.EmailTemplates.map((template: IEmailTemplate) => {
            if (template.email_template_id === template_id) {
                return {
                    ...template,
                    Sections: template.Sections.map((section: IEmailTemplateSection) => {
                        if (section.email_template_section_id === section_id) {
                            return {
                                ...section,
                                RTEValue: e,
                                EmailSectionContent: e.toString('html')
                            }
                        }
                        return section
                    })
                }
            }
            return template
        })
    }

    public saveEmailTemplate = (emailTemplate: IEmailTemplate) => {
        settingsStore.saveEmailTemplate(emailTemplate);
    }

    @action
    public handleEmailSelectChange = (e: any) => {
        settingsStore.active_template_id = e.target.value;
        settingsStore.template_saved = false;
    }

    public emailContentDisplay = (emailTemplate: IEmailTemplate) => {
        return (
            <Grid container={true} spacing={8} style={{ overflowX: 'hidden' }}>
                {/* <Grid item={true} xs={12}>
                    <Typography variant={'h4'} align={'center'}>{emailTemplate.EmailTemplateName}</Typography>
                </Grid> */}
                <Grid item={true} xs={3} style={{ padding: '15px' }}>
                    <Button
                        // classes={{ root: classes.submitButton }}
                        disabled={settingsStore.template_saved}
                        // tslint:disable-next-line: jsx-no-lambda
                        onClick={() => this.saveEmailTemplate(emailTemplate)}
                        variant='contained'
                    >
                        Save Email Template
                    </Button>
                    <Typography variant={'h5'}>Variables</Typography>
                    <Divider />
                    {emailTemplate.Variables.map((variable: IEmailVariable) => {
                        return (
                            <React.Fragment key={variable.email_template_variable_id}>
                                <Grid container={true} style={{ padding: '10px' }}>
                                    <Grid item={true} xs={10}>
                                        <Typography style={{ fontSize: '16px' }}>{variable.EmailTemplateVariable}</Typography>
                                    </Grid>
                                    <Grid item={true} xs={2}>
                                        <Tooltip title={variable.EmailTemplateVariableDescription}>
                                            <InfoIcon />
                                        </Tooltip>
                                    </Grid>
                                </Grid>
                                <Divider />
                            </React.Fragment>
                        )
                    })}
                </Grid>
                <Grid item={true} xs={9} style={{ padding: '15px' }}>
                    {emailTemplate.Sections.map((section: IEmailTemplateSection) => {
                        return (
                            <Grid key={section.email_template_section_id} item={true} xs={12} style={{ padding: '10px' }}>
                                <Paper>
                                    <Typography variant={'h6'}>{section.EmailSectionName}</Typography>
                                    <RichTextEditor
                                        toolbarConfig={this.toolbarConfig}
                                        value={section.RTEValue}
                                        // tslint:disable-next-line: jsx-no-lambda
                                        onChange={(e) => this.handleContentChange(e, section.email_template_id, section.email_template_section_id)}
                                        className='h-full'
                                    />
                                </Paper>
                            </Grid>
                        )
                    })}
                </Grid>

            </Grid>

        )
    }

    public render() {
        const { classes } = this.props;

        if (!settingsStore.email_templates_loaded) {
            return <div>Loading</div>
        };

        return (
            <div className={classes.root}>
                <FormControl className={classes.formControl}>
                    <Select
                        value={settingsStore.active_template_id}
                        onChange={this.handleEmailSelectChange}
                        name="age"
                        className={classes.emailSelect}
                    >
                        {settingsStore.EmailTemplates.map((template: IEmailTemplate) => {
                            return (
                                <MenuItem key={template.email_template_id} value={template.email_template_id}>{template.EmailTemplateName}</MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>
                {settingsStore.EmailTemplates.filter((template: IEmailTemplate) => template.email_template_id === settingsStore.active_template_id).map((template: IEmailTemplate) => {
                    return (
                        <div style={{ overflowY: 'scroll', overflowX: 'hidden', marginBottom: '20px' }} key={template.email_template_id}>{this.emailContentDisplay(template)}</div>
                    )
                })}
            </div>
        );
    }

}

export default withStyles(styles, { withTheme: true })(SignUpEmailTemplate);


// WEBPACK FOOTER //
// ./src/modules/admin/modules/Settings/SignUpEmailTemplate.tsx